<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { generateUUID } from "@/utils";
export default {
  name: "week-time",
  props: ["item", "timepos", "label"],
  components: {
    VueCtkDateTimePicker
  },
  data() {
    return {
      dtpicker:
        this.timepos == "start" ? this.item.start_time : this.item.end_time,
      dt: ""
    };
  },
  computed: {
    dtpickerId() {
      let uuid = generateUUID();
      return `${this.timepos}_${uuid}`;
    }
  },
  watch: {
    dtpicker() {
      this.dt = this.dtpicker;
      this.$emit("input");
    }
  }
};
</script>

<template>
  <div>
    <input
      type="hidden"
      class="week-time"
      :timepos="timepos"
      :day="item.week_day"
      v-model="dt"
    />
    <VueCtkDateTimePicker
      :id="dtpickerId"
      v-model="dtpicker"
      onlyTime
      format="hh:mm a"
      formatted="hh:mm a"
      :label="label"
    />
  </div>
</template>
